export var socialmediaFacebook = [
    'M10.79 8.75L11.13 6.58H9.04V5.17C9.04 4.58 9.33 3.99 10.27 3.99H11.21V2.15C11.21 2.15 10.35 2 9.53 2C7.82 2 6.69 3.04 6.69 4.92V6.58H4.79V8.75H6.7V14H9.04V8.75H10.79Z',
];
